'use strict';

/* eslint no-undef: "off" */
/**
 * header 顶部
 */
define('headerQuick',['util', 'busEvent', 'logo', 'svgIcon', 'getCartApi', 'getCityListApi', 'appStorage', 'GAReport'], function (Util, busEvent, logo, svgIcon, getCartApi, getCityListApi, appStorage, GAReport) {
  return {
    template: '\n      <div class="in-header-quick">\n        <div class="xp-header-logo">\n            <a href="/" @click="onLogoClicked">\n                <logo></logo>\n            </a>\n            <div class="xp-header-city"  @click="onChangeCity">\n              <svg-icon type="locationLine"></svg-icon>\n              <span v-text="currentCityName"></span>\n            </div>\n        </div>\n        <div class="xp-header-actions">\n          <a href="javascript:void(0)" class="xp-header-action" @click.prevent="showSearchPanel">\n            <svg-icon type="search"></svg-icon>\n          </a>\n          <input class="xp-header-search-proxy" type="search" name="search" :placeholder="i18n.search" readonly @focus.prevent="showSearchPanel"/>\n          <a href="/checkout/cart" class="xp-header-action xp-header-cart" @click="onCartBtnClicked">\n            <svg-icon type="cart"></svg-icon>\n            <span class="xp-header-cart-badge" v-if="count !== 0" v-text="count > 9 ? \'\xB7\xB7\xB7\' : count"></span>\n          </a>\n          <a :href="accountUrl" class="xp-header-action" @click="onAccountBtnClicked">\n            <svg-icon type="account"></svg-icon>\n          </a>\n          <a href="javascript:void(0)" class="xp-header-action" @click.prevent="openMenu($event)">\n            <svg-icon type="menu"></svg-icon>\n          </a>\n        </div>\n      </div>\n    ',
    data: function data() {
      return {
        loginUrl: window.commonDataJSON.login_url,
        logoutUrl: '/customer/account/logout/',
        stores: window.commonDataJSON.stores,
        isLogin: !!appStorage.get('token'),
        count: 0,
        areaList: [],
        curArea: null,
        curCity: null,
        i18n: {
          login: 'LOGIN',
          register: 'REGISTER',
          logout: 'LOGOUT',
          search: 'search'
        }
      };
    },

    components: {
      logo: logo,
      svgIcon: svgIcon
    },
    computed: {
      accountUrl: function accountUrl() {
        return window.localStorage.token ? '/customer/account' : this.loginUrl;
      },
      currentCityName: function currentCityName() {
        return this.curCity && (this.curCity.name || this.curCity.text) || 'IKEJA';
      }
    },
    mounted: function mounted() {
      var _this = this;

      getCartApi().then(this.flashCart.bind(this));
      appStorage.onChange('cart', this.flashCart.bind(this));
      this.getCityList();
      busEvent.$on('resetPosition', function () {
        _this.getCityList();
      });
    },

    methods: {
      getCityList: function getCityList() {
        var _this2 = this;

        getCityListApi().then(function (resData) {
          _this2.areaList = Array.isArray(resData) ? resData : [];
          _this2.filterCurCity();
        });
      },
      filterCurCity: function filterCurCity() {
        var _this3 = this;

        var defaultArea = this.areaList[0] || null;
        var defaultCity = this.getDefaultCity(defaultArea);

        this.areaList.forEach(function (area) {
          if (_this3.isDefault(area)) {
            defaultArea = area;
            defaultCity = _this3.getDefaultCity(area);
          }

          _this3.getChildren(area).forEach(function (city) {
            if (_this3.isDefault(city)) {
              defaultArea = area;
              defaultCity = city;
            }
          });
        });

        this.curArea = defaultArea;
        this.curCity = defaultCity || {
          name: 'IKEJA',
          id: ''
        };
      },
      getDefaultCity: function getDefaultCity(area) {
        var _this4 = this;

        var children = this.getChildren(area);
        var defaultCity = children[0] || null;

        children.forEach(function (city) {
          if (_this4.isDefault(city)) {
            defaultCity = city;
          }
        });

        return defaultCity;
      },
      getChildren: function getChildren(area) {
        return area && Array.isArray(area.children) ? area.children : [];
      },
      isDefault: function isDefault(item) {
        return item && (item.is_default === true || item.is_default === 1 || item.is_default === '1' || item.isChecked === true || item.isChecked === 1);
      },
      flashCart: function flashCart(aft) {
        if (aft) {
          this.count = aft.count;
        }
      },
      showSearchPanel: function showSearchPanel() {
        busEvent.$emit('closeMenuEvent');
        busEvent.$emit('showSearchEvent');
      },
      openMenu: function openMenu(event) {
        $('body').addClass('in-menu-open');
      },
      openCountryChoose: function openCountryChoose() {
        if (Util.isH5App()) {
          window.Native && window.Native.changeCounrty();
        } else {
          $('body').addClass('in-country-open');
        }
        this.onCountryBtnClicked();
      },
      onLogoClicked: function onLogoClicked() {
        new GAReport().customerClick({
          eventAction: 'PAGE_#PAGEGROUP#',
          eventCategory: 'ICON_#VERSION#_CLICK'
        });
      },
      onCountryBtnClicked: function onCountryBtnClicked() {
        new GAReport().customerClick({
          eventAction: 'TOP_COUNTRY_CHANGE_ENTRY',
          eventCategory: 'TOP_COUNTRY_CHANGE_#VERSION#'
        });
      },
      onCartBtnClicked: function onCartBtnClicked() {
        new GAReport().customerClick({
          eventAction: 'TOP_CART_ENTRY',
          eventCategory: 'TOP_CART_#VERSION#'
        });
      },
      onAccountBtnClicked: function onAccountBtnClicked() {
        var action = window.localStorage.token ? "ACCOUNT" : "LOGIN";
        new GAReport().customerClick({
          eventAction: 'TOP_ENTRY_' + action,
          eventCategory: 'USER_#VERSION#'
        });
      },
      onChangeCity: function onChangeCity() {
        this.openMenu();
        busEvent.$emit("openSideMenuChangeCity");
      }
    }
  };
});
